import { events } from "@nuskin/ns-util";

/**
 * Helper to wait for certain config maps to be loaded that are used
 * in dependent nuskin packages.
 *
 * @returns {Promise}
 */
const waitForConfig = async () => {
  const promise = new Promise(resolve => {
    // Wait for this maps to be loaded.
    const neededMaps = ["Url", "Basic", "Shopping", "ADP", "Cart", "Loyalty", "Checkout"]; // eslint-disable-line

    const isSubset = (array1, array2) => {
      return array2.every(element => array1.includes(element));
    };

    const configCallback = configs => {
      if (configs && isSubset(configs, neededMaps)) {
        events.unsubscribe(events.global.CS_CONFIG_SET, configCallback);
        resolve();
      }
    };

    events.getValue(events.global.CS_CONFIG_SET, configCallback, true);
  });

  return promise;
};

export { waitForConfig };
